import {Indicator} from '@radix-ui/react-progress';
import clsx from 'clsx';

import type {ProgressProps} from '@radix-ui/react-progress';

type Props = React.ComponentProps<typeof Indicator> &
  Pick<ProgressProps, 'value' | 'max'>;
export function ProgressIndicator({
  value,
  max,
  ...props
}: Props): React.JSX.Element {
  const className = clsx(
    'ease-[cubic-bezier(0.65, 0, 0.35, 1)] h-full w-full transition-transform duration-500',
    props.className
  );

  const _value = typeof value === 'number' ? value : 0;
  const _max = typeof max === 'number' ? max : 100;

  return (
    <Indicator
      {...props}
      style={{transform: `translateX(-${100 - (_value / _max) * 100}%)`}}
      className={className}
    />
  );
}

ProgressIndicator.displayName = 'ProgressIndicator';
